import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _templateObject = _taggedTemplateLiteral(['\n\t\t\tquery getProduct {\n\t\t\t\tshop{\n\t\t\t\t\t\tproductByHandle(handle:"', '"){\n\t\t\t\t\t\t  title\n\t\t\t\t\t\t  id\n\t\t\t\t\t\t  onlineStoreUrl\n\t\t\t\t\t\t  variants(first:1){\n\t\t\t\t\t\t  \tedges{\n\t\t\t\t\t\t  \t\tnode{\n\t\t\t\t\t\t  \t\t\tpriceV2{\n\t\t\t\t\t\t  \t\t\t\tamount\n\t\t\t\t\t\t  \t\t\t\tcurrencyCode\n\t\t\t\t\t\t  \t\t\t}\n\t\t\t\t\t\t  \t\t}\n\t\t\t\t\t\t  \t}\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  images(first:1) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        altText\n\t\t\t\t\t\t        originalSrc\n\t\t\t\t\t\t        thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t        productImg: transformedSrc(maxWidth:600, maxHeight: 800)\n\t\t\t\t\t\t        productImgMain:transformedSrc(maxWidth:900, maxHeight:480, crop: CENTER)\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t}\n\t\t'], ['\n\t\t\tquery getProduct {\n\t\t\t\tshop{\n\t\t\t\t\t\tproductByHandle(handle:"', '"){\n\t\t\t\t\t\t  title\n\t\t\t\t\t\t  id\n\t\t\t\t\t\t  onlineStoreUrl\n\t\t\t\t\t\t  variants(first:1){\n\t\t\t\t\t\t  \tedges{\n\t\t\t\t\t\t  \t\tnode{\n\t\t\t\t\t\t  \t\t\tpriceV2{\n\t\t\t\t\t\t  \t\t\t\tamount\n\t\t\t\t\t\t  \t\t\t\tcurrencyCode\n\t\t\t\t\t\t  \t\t\t}\n\t\t\t\t\t\t  \t\t}\n\t\t\t\t\t\t  \t}\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t  images(first:1) {\n\t\t\t\t\t\t    edges {\n\t\t\t\t\t\t      node {\n\t\t\t\t\t\t        altText\n\t\t\t\t\t\t        originalSrc\n\t\t\t\t\t\t        thumbnailImg: transformedSrc(maxWidth:100, maxHeight: 120, crop:CENTER)\n\t\t\t\t\t\t        productImg: transformedSrc(maxWidth:600, maxHeight: 800)\n\t\t\t\t\t\t        productImgMain:transformedSrc(maxWidth:900, maxHeight:480, crop: CENTER)\n\t\t\t\t\t\t      }\n\t\t\t\t\t\t    }\n\t\t\t\t\t\t  }\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t}\n\t\t']);

import React, { Component } from 'react';

import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import Product from './product';
import './recommended_products.css';

var _ref = React.createElement(
	'div',
	{ className: 'section-title' },
	React.createElement(
		'h2',
		null,
		'Recommended Products'
	)
);

var _ref2 = React.createElement(
	'h2',
	null,
	'Recommended Products'
);

var _ref4 = React.createElement('div', null);

var _ref5 = React.createElement(
	'div',
	{ className: 'loading' },
	'Loading...',
	React.createElement(
		'div',
		{ className: 'loader' },
		React.createElement('span', { className: 'inner1' }),
		React.createElement('span', { className: 'inner2' }),
		React.createElement('span', { className: 'inner3' })
	)
);

var RecommendedProducts = function (_Component) {
	_inherits(RecommendedProducts, _Component);

	function RecommendedProducts() {
		_classCallCheck(this, RecommendedProducts);

		return _possibleConstructorReturn(this, (RecommendedProducts.__proto__ || Object.getPrototypeOf(RecommendedProducts)).call(this));
	}

	_createClass(RecommendedProducts, [{
		key: 'createProductQuery',
		value: function createProductQuery(handle) {
			return gql(_templateObject, handle);
		}
	}, {
		key: 'render',
		value: function render() {
			var _this2 = this;

			var _props = this.props,
			    products = _props.products,
			    sectionTitle = _props.sectionTitle;

			return React.createElement(
				'section',
				{ className: 'wrapper' },
				sectionTitle ? _ref : _ref2,
				React.createElement(
					'div',
					{ className: 'recommended-products' },
					products.map(function (product) {
						return React.createElement(
							'div',
							{ key: product },
							React.createElement(
								Query,
								{ query: _this2.createProductQuery(product) },
								function (_ref3) {
									var loading = _ref3.loading,
									    err = _ref3.err,
									    data = _ref3.data;

									if (!loading) {
										if (data.productByHandle) {											return React.createElement(Product, { product: data.productByHandle });
										} else {
											return _ref4;
										}
									} else {
										return _ref5;
									}
								}
							)
						);
					})
				)
			);
		}
	}]);

	return RecommendedProducts;
}(Component);

export default RecommendedProducts;